import Task from "../../core/model2/task/task"
import {ChatType} from "../../core/model2/chat/chat/const"
import {RequestFormType} from "../tools/request-forms2/const/const"
import {EventType} from "../../core/gd/const/event"
import {ViewType} from "../../core/gd/const/views/view-type"
import {TagType} from "../../core/model2/tag/const"
import {NewDashboard_SelectedType} from "./sections/dashboard/new-dasshboard-main";

export enum QuickAddItemType {

    // Structure
    FOLDER                      = 'folder',
    // WORKSPACE                   = 'workspace',
    PROJECT                     = 'project',
    PAGE                        = 'page',
    GROUP                       = 'group',
    SECTION                     = 'section',
    LINK                        = 'link',
    EMBED                       = 'embed',
    TEMPLATES                   = 'public-templates',
    DATABASE                    = 'database-internal',
    SUPPORT_SYSTEM              = 'support-system',
    SPACE                       = 'space',
    WHITEBOARD                  = 'whiteboard',


    // Old

    TASK                        = 'task',
    SUBTASK                     = 'subtask',
    EXPENSE                     = 'expense',
    MEETING                     = 'meeting',
    USER                        = 'user',
    PORTFOLIO                   = 'portfolio',
    VIEW                        = 'view',

    DASHBOARD                   = 'dashboard',
    CUSTOM_DASHBOARD            = 'custom-dashboard',
    PROJECT_DASHBOARD           = 'project-dashboard',
    CHAT                        = 'chat',
    REQUEST_FORM                = 'request-form',
    REQUEST                     = 'request',
    WIDGET                      = 'widget',
    TAG                         = 'tag',
    DOCUMENT                    = 'document',
    CRM                         = 'crm',
    EVENT                       = 'event',
    GOAL                        = 'goal',
    REMINDER                    = 'reminder',
    AUTOMATION                  = 'automation',
    AUTOMATION_FROM_TEMPLATE    = 'automation-from-template',
    ACTION                      = 'action',
}

export const QuickAddBreadcrumbElement = {
    PROJECT_RESOURCES: {
        label   : "Project & Resources",
        onClick : ()=>{gd.openNew(QuickAddItemType.PROJECT)}
    },
    WORKSPACE: {
        label   : "Space",
        onClick : ()=>{gd.openNew(QuickAddItemType.SPACE)}
    },
    PAGE: {
        label   : "Page",
        onClick : ()=>{gd.openNew(QuickAddItemType.PAGE)}
    },
    PROJECT_TEMPLATE_LIBRARY: {
        label   : "Template Library",
        onClick : ()=>{gd.openNew(QuickAddItemType.PROJECT, {templatesLibrary: true})}
    },
    EVENT: {
        label   : "Event",
        onClick : ()=>{gd.openNew(QuickAddItemType.EVENT)}
    },
    DASHBOARD: {
        label   : "Dashboard",
        onClick : ()=>{gd.openNew(QuickAddItemType.DASHBOARD)}
    },
    CUSTOM_DASHBOARD: {
        label   : "Custom Dashboard",
        onClick : ()=>{gd.openNew(QuickAddItemType.DASHBOARD, {type: NewDashboard_SelectedType.CUSTOM})}
    },
    PROJECT_DASHBOARD: {
        label   : "Project Dashboard",
        onClick : ()=>{gd.openNew(QuickAddItemType.DASHBOARD, {type: NewDashboard_SelectedType.PROJECT})}
    },
    DOCUMENT: {
        label   : "New Document",
        onClick : ()=>{gd.openNew(QuickAddItemType.DOCUMENT)}
    },
    CHAT: {
        label   : "New Chat / Discussion",
        onClick : ()=>{gd.openNew(QuickAddItemType.CHAT)}
    },
    TAG: {
        label   : "New Tag",
        onClick : ()=>{gd.openNew(QuickAddItemType.TAG)}
    },
    CRM: {
        label   : "CRM",
        onClick : ()=>{gd.openNew(QuickAddItemType.CRM)}
    },
    VIEW: {
        label   : "New View",
        onClick : ()=>{gd.openNew(QuickAddItemType.VIEW)}
    },
    REQUEST: {
        label   : "Request",
        onClick : ()=>{gd.openNew(QuickAddItemType.REQUEST)}
    },
    AUTOMATION: {
        label   : "New Automation",
        onClick : ()=>{gd.openNew(QuickAddItemType.AUTOMATION)}
    },
    USER: {
        label   : "Invite user",
        onClick : ()=>{gd.openNew(QuickAddItemType.USER)}
    },
    PORTFOLIO: {
        label   : "New Portfolio",
        onClick : ()=>{gd.openNew(QuickAddItemType.PORTFOLIO)}
    },
}

export type QuickAddParams = {


    id?                     : ID // Request

    projectId?              : ID
    projectType?            : string

    task?                   : Task

    type?                   : 'invite-customer' | 'invite-user' | ChatType | RequestFormType | 'contact' | 'account' | TagType | ViewType

    crmAccountId?           : ID

    organizationId?         : ID
    company?                : ID    // view

    callback?               : callback

    location?               : any   // add a view ?
    parentProjectId?        : ID    // for views in structure (because projectId parameter is added automatically if project app is currently opened, therefore it can't be used)

    onNewTaskCallback?      : callback
    onNewProjectCallback?   : callback


    eventType?              : EventType
    onNewEventCallback?     : callback

    templateId?             : ID // new project
    templatesLibrary?       : boolean

    startDate?              : Moment    // used in task when create from calendar
    endDate?                : Moment    // used in tasks when create from calendar
    deadline?               : Moment    // used in task when create from calendar
    scheduleDate?           : Moment    // used in task when create from calendar


    isTemplate?             : boolean   // dlya add event ono ne nuzno na samom dele nado project brat' iz tempalte a ne tut
    userId?                 : ID        // used in task to pass user...

    viewSystemType?         : ViewType // for embed project
}
